module.exports = __webpack_public_path__ + "static/media/placeholder.898a454a.jpg";